import classNames from 'classnames';
import { createElement, type CSSProperties, type HTMLAttributes, type JSX } from 'react';

import { type TypographyBaseProps } from './types';

type TypographyProps = TypographyBaseProps & HTMLAttributes<HTMLElement>;

export const Typography = ({
  variant = 'body',
  size = 'medium',
  tagName = 'p',
  color,
  font = 'body',
  className,
  style,
  children,
  value,
  singleLine = false,
  ...restProps
}: TypographyProps) => {
  const Tag = (tagName ?? 'p') as keyof JSX.IntrinsicElements;

  const commonClassName = classNames(
    'typography',
    `typo-${variant}`,
    `typo-${size}`,
    `typo-font-${font}`,
    singleLine && 'typo-single-line',
    className,
  );

  const mergedStyle: CSSProperties = {
    ...(style ?? {}),
    ...(typeof color === 'string' && color.trim() !== '' ? { color } : {}),
  };
  const content = children ?? value ?? null;

  // If content is a string and contains HTML tags, render as HTML
  const shouldRenderAsHtml = typeof content === 'string' && /<[^>]+>/.test(content);

  if (shouldRenderAsHtml) {
    return createElement(Tag, {
      className: commonClassName,
      style: mergedStyle,
      dangerouslySetInnerHTML: { __html: content as string },
      ...restProps,
    });
  }

  return createElement(
    Tag,
    {
      className: commonClassName,
      style: mergedStyle,
      ...restProps,
    },
    content,
  );
};
